import { Pipe, type PipeTransform } from '@angular/core';

export const TRUNCATE_LIMIT_DEFAULT = 600;

@Pipe({
  name: 'truncate',
  standalone: true,
})
export class TruncatePipe implements PipeTransform {
  transform(value?: any, limit: number = TRUNCATE_LIMIT_DEFAULT): string {
    return truncate(value, limit);
  }
}

export function truncate(value?: any, limit: number = TRUNCATE_LIMIT_DEFAULT) {
  if (typeof value !== 'string') {
    return value;
  }

  if (!value) {
    return '';
  }

  value = cutStringAfterHashes(value);

  if (value.length <= limit) {
    return value;
  }

  return value.substring(0, limit) + '...';
}

function cutStringAfterHashes(inputString: string) {
  var index = inputString.indexOf('###');
  if (index !== -1) {
    return inputString.substring(0, index);
  }
  return inputString;
}
